import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { CcStudyParticipant } from '../../../../models/cc-study-participant';

export const getCcStudyParticipants = createAction(
  '[CcStudyParticipants] Get CC Study Participants',
  props<{ studyId: number }>()
);

export const getCcStudyParticipantsSuccess = createAction(
  '[CcStudyParticipants] Get CC Study Participants Success',
  props<{ ccStudyParticipants: CcStudyParticipant[] }>()
);

export const getCcStudyParticipantsError = createAction(
  '[CcStudyParticipants] Get CC Study Participants Error',
  props<{ error: HttpErrorResponse }>()
);

export const deleteCcStudyParticipant = createAction(
  '[CcStudyParticipants] Delete CC Study Participant',
  props<{ studyId: number; ccStudyParticipantId: number }>()
);

export const deleteCcStudyParticipantSuccess = createAction(
  '[CcStudyParticipants] Delete CC Study Participant Success',
  props<{ deletedCcStudyParticipantId: number }>()
);

export const deleteCcStudyParticipantError = createAction(
  '[CcStudyParticipants] Delete CC Study Participant Error',
  props<{ error: HttpErrorResponse }>()
);
